/**
 * Radix's DropdownMenu opens on pointerdown and on Enter/Space keydown, so
 * a click that comes with neither — an agent's `element.click()`, a
 * WebMCP or test script, some assistive tech — did nothing (#397 review).
 * Those clicks carry `event.detail === 0` (no real press); a mouse click
 * says 1+. Only open, never toggle: Enter/Space already opened the menu on
 * keydown, and a keyboard-fired click (also detail 0) must not close it.
 *
 * @param {(open: boolean) => void} setOpen the controlled menu's setter
 * @returns {(event: MouseEvent) => void} the trigger's onClick
 */
export function openOnScriptedClick(setOpen) {
  return (event) => {
    if (event.detail === 0) setOpen(true);
  };
}
